import script from "./AddMitreTagTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMitreTagTemplate.vue?vue&type=script&setup=true&lang=js"

import "./AddMitreTagTemplate.vue?vue&type=style&index=0&id=f6d75464&lang=scss&scoped=true"
import "./AddMitreTagTemplate.vue?vue&type=style&index=1&id=f6d75464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6d75464"]])

export default __exports__